import PageTile from './page-tile';

export default PageTile;
